import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/cloudinary/`;

const uploadWeeklyShipImage = async (formData) => {
  return await axios.post(API_URL + 'shipimage/upload', formData);
};

const uploadReceiptImage = async (formData) => {
  return await axios.post(API_URL + 'receipt/upload', formData);
};

const uploadAirShipImage = async (formData) => {
  return await axios.post(API_URL + 'shipimage/air/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export default {
  uploadWeeklyShipImage,
  uploadReceiptImage,
  uploadAirShipImage
};